/**
 * TODO (russell): This component is not yet a collage. Right now it's just a
 * wrapper around a static image.
 */

import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {mediaQueries, pureLgMin} from "@khan/shared-styles";
import {staticUrl} from "@khan/urls";

const LevelPlayingFieldCollage = (): React.ReactElement<
    React.ComponentProps<"picture">
> => {
    return (
        // eslint-disable-next-line jsx-a11y/aria-unsupported-elements -- TODO: Address a11y error
        <picture className={css(styles.picture)} aria-hidden="true">
            <source
                media={`(min-width: ${pureLgMin})`}
                srcSet={staticUrl(
                    "/images/lohp/level-playing-field-desktop@2x.jpg",
                )}
            />
            <img
                className={css(styles.img)}
                alt=""
                src={staticUrl("/images/lohp/level-playing-field@2x.jpg")}
            />
        </picture>
    );
};

const styles = StyleSheet.create({
    picture: {
        [mediaQueries.mdOrSmaller]: {
            textAlign: "center",
        },
    },
    img: {
        margin: "auto",

        [mediaQueries.smOrSmaller]: {
            width: "100%",
            transform: "scale(1.5) translateY(-12%)",
        },
        [mediaQueries.md]: {
            width: "100%",
        },
        [mediaQueries.lgOrLarger]: {
            margin: "initial",
            width: "121%",
            transform: "translate(-11%, -2%)",
        },
        [mediaQueries.xlOrLarger]: {
            width: "115%",
            transform: "translate(-10%, -8%)",
        },
    },
});

export default LevelPlayingFieldCollage;
